export default __webpack_public_path__ + "ff6b7ebee1eab4b6c937d71d0ebcb69f.png";